import { Asset } from "@dexteel/mesf-core/dist/models/Asset";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { getAssets } from "../../../shared/repositories/AssetRepository";
import { CatalogDelayCodePage } from "./CatalogDelayCodePage";
import {
  DELAY_CODE_LABELS,
  type DelayCodeLabelVariant,
} from "./delayCodeLabels";

interface Props {
  delayAreaAssetName?: string;
  displayName?: string;
  variant?: DelayCodeLabelVariant;
}

const DelayCodePage = ({
  delayAreaAssetName,
  displayName,
  variant = "delayCode",
}: Props) => {
  const [delayAreaAsset, setDelayAreaAsset] = useState<Asset[]>([]);
  const [assetId, setAssetId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getDelayAreaAsset = async () => {
    try {
      setIsLoading(true);
      const response = await getAssets();
      if (response.ok) {
        const assets = get(response, "data.tables[0].rows", []);
        setDelayAreaAsset(assets);
      } else {
        setError("Error fetching assets");
      }
    } catch (err) {
      setError("Error fetching assets");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (delayAreaAsset.length > 0) {
      const foundAssetId =
        delayAreaAsset.find(
          (asset: Asset) => asset.AssetName === delayAreaAssetName,
        )?.AssetId ?? null;
      setAssetId(foundAssetId);
    }
  }, [delayAreaAsset, delayAreaAssetName]);

  useEffect(() => {
    getDelayAreaAsset();
  }, []);

  if (!assetId || isLoading) return null;
  if (error) return <div>{error}</div>;
  return (
    <CatalogDelayCodePage
      delayAreaAssetId={assetId}
      delayAreaAssetName={delayAreaAssetName}
      displayName={displayName}
      labels={DELAY_CODE_LABELS[variant]}
    />
  );
};

export default DelayCodePage;
